import { iaRa, inRn } from 'lib/helpers/utility';
import { PAID_TRANSACTION_STATUSES } from 'lib/constants/transaction/completedTransactionStatuses';

export const calculateTotals = (transactions) => {
  return iaRa(transactions).reduce(
    (acc, transaction) => {
      const {
        total_amount = 0,
        write_off = 0,
        discount = 0,
        tax = 0,
        amount_paid = 0,
        balance = 0
      } = transaction.invoice || transaction;

      return {
        totalAmount: acc.totalAmount + total_amount,
        totalWriteOff: acc.totalWriteOff + write_off,
        totalDiscount: acc.totalDiscount + discount,
        totalTax: acc.totalTax + tax,
        totalAmountPaid: acc.totalAmountPaid + amount_paid,
        totalBalance: acc.totalBalance + balance,
        calculatedTotal: acc.calculatedTotal + total_amount - discount - write_off + tax
      };
    },
    {
      totalAmount: 0,
      totalWriteOff: 0,
      totalDiscount: 0,
      totalTax: 0,
      totalAmountPaid: 0,
      totalBalance: 0,
      calculatedTotal: 0
    }
  );
};

export const calculateWalkoutPaid = (walkoutTransactions) => {
  return iaRa(walkoutTransactions).reduce((acc, transaction) => {
    const { type, status, amount_paid_self } = transaction || {};

    if (type === 'void' || type === 'refund') return acc;
    if (!PAID_TRANSACTION_STATUSES.includes(status?.toLowerCase())) return acc;

    return acc + inRn(amount_paid_self);
  }, 0);
};
